// extracted by mini-css-extract-plugin
export default {"wrapper":"MainVideoBG_wrapper__9sa8Y","logo":"MainVideoBG_logo__9roP4","text":"MainVideoBG_text__bOrny"};